import { _ } from "../polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import regionWidget from "../widgets/regionWidget.js";

/**
 * Render a block for the actions menu that is collapsed.
 * A link is displayed to toggle the block.
 *
 * @param {Renderable} spec.content - Content of the block to be rendered.
 */
export default class CollapsedActionsBlockWidget extends Widget {
	constructor({ content }) {
		super(...arguments);
		this._content = content;
		this._collapsed = true;

		this._link = regionWidget({ content: this._renderLinkOn.bind(this) });
	}

	toggle() {
		this._collapsed = !this._collapsed;

		this.asJQuery()
			.find(".action-block")
			.slideToggle(400, () => this._link.update());
	}

	renderContentOn(html) {
		html.div(
			{ klass: ["action-block", { collapsed: this._collapsed }] },
			this._content,
		);

		html.div({ klass: "action-block-toggle" }, this._link);
	}

	_renderLinkOn(html) {
		html.a(
			{
				click: this.toggle.bind(this),
				"data-test": `show-${this._collapsed ? "more" : "less"}`,
			},
			this._collapsed ? _("Show more") : _("Show less"),
		);
	}
}
